type ContactFormPayload = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

type EnquiryResponse = {
  success: boolean;
  message: string;
};

export class ContactService {
  static async sendEnquiry(enquiryUrl: string, payload: ContactFormPayload): Promise<EnquiryResponse> {
    if (!enquiryUrl) {
      throw new Error("Enquiry URL is not defined.");
    }

    // Retry logic with exponential backoff
    const fetchWithRetry = async (url: string, options: RequestInit, maxRetries: number = 3): Promise<Response> => {
      let lastError: unknown = null;
      for (let i = 0; i < maxRetries; i++) {
        try {
          const response = await fetch(url, options);
          if (response.status >= 500) {
            throw new Error(`Server error: ${response.status}`);
          }
          return response;
        } catch (error) {
          lastError = error;
          if (i < maxRetries - 1) {
            const delay: number = Math.pow(2, i) * 1000; // 1s, 2s, 4s delay
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }
      }
      throw lastError;
    };

    const response = await fetchWithRetry(enquiryUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    return {
      success: response.ok,
      message: result.message || (response.ok ? 'Success' : 'An error occurred.'),
    };
  }
}
